import { type ModalProps as BaseUiModalProps, Spin } from '@faceup/ui-base'
import { Suspense } from 'react'

type ModalProps = Pick<BaseUiModalProps, 'open'>

type WithModalSuspenseProps<T extends ModalProps> = T & ModalProps

export const withModalSuspense = <T extends ModalProps>(Component: React.ComponentType<T>) => {
  return (props: WithModalSuspenseProps<T>) => {
    if (!props.open) {
      return null
    }
    return (
      <Suspense fallback={<Spin size='large' fullscreen />}>
        <Component {...props} />
      </Suspense>
    )
  }
}
